module.exports = __webpack_public_path__ + "img/024.cef8093a.png";